<template>

  <div class="product-list" v-if="order_info.user!=null">
    <CCard>
      <CCardHeader>
        <strong>
          اطلاعات سفارش
        </strong>
        <strong>
          مبلغ کل: {{ get_currency(order_info.total_price) }}
        </strong>
        <strong>
          {{ status_items.filter(x => x.value == order_info.statuses[0].id)[0].label }}
        </strong>
        <strong>
          <CButton
              @click="tracking_post_modal=true"
              color="info">
            کد مرسوله
          </CButton>
          <CButton
              @click="print()"
              color="success"
              class="mx-1">
            پرینت اطلاعات
          </CButton>
          <CButton v-if="order_info.statuses[0].id!=5"
              @click="$router.push({path:'/dashboard/orders/edit-order/'+order_info.id})"
              color="warning"
              class="mx-1">
            ویرایش سفارش
          </CButton>
        </strong>
      </CCardHeader>

      <CCardBody class="">
        <div id="print_order_area" style="display:none">
          <div style=";width: 69mm;margin-left: 5px;color: black">
            <div style="justify-self: center;">
              <img :src="logo_image"  style="width:120px;height:30px" />
            </div>
            <h5 class="m-0" style="font-size: 20px;color: black">عمده شو</h5>
            <CRow>
              <CCol col="6"><label style="font-size:14px">گیرنده : {{ order_info.user.name }}</label></CCol>
              <CCol col="6"><label style="font-size:14px">ت. فاکتور : {{ get_date_time(order_info.date) }}</label>
              </CCol>
              <CCol col="6"><label style="font-size:14px">تلفن خریدار : {{ order_info.user.phone }}</label></CCol>
              <CCol col="6"><label style="font-size:14px">ش فاکتور : {{ order_info.id }}</label></CCol>
              <CCol col="12" style="font-size:14px">
                <div style="font-size:14px">نشانی:</div>
                <div style="font-size:14px">
                  <label style="font-size:14px">{{ order_info.address.province }},{{
                      order_info.address.city
                    }},{{ order_info.address.address }}</label>

                  <div class="mx-3" style="font-size:14px">{{ order_info.address.post_code }}</div>
                </div>
              </CCol>


            </CRow>
            <CRow style=";border-bottom: 2px solid black">
              <CCol col="3">
                تعداد
              </CCol>

              <CCol col="3">
                قیمت
              </CCol>
              <CCol col="3">
                تخفیف
              </CCol>
              <CCol col="3">
                قابل پرداخت
              </CCol>
            </CRow>
            <CRow v-for="item in order_info.products" style=";border-bottom: 2px solid black">
              <CCol col="12">
                {{ item.title }}
                ({{item.code}})
              </CCol>
              <CCol col="3">
                {{
                  Math.abs(item.count)
                }}
              </CCol>

              <CCol col="3">
                {{ get_currency(item.price) }}
              </CCol>
              <CCol col="3">
                {{ get_currency(item.off) }}
              </CCol>
              <CCol col="3">
                {{ get_currency(item.total_price) }}
              </CCol>

            </CRow>

            <CRow>
              <CCol col="12">
                <table>
                  <tr>
                    <td>مبلغ فاکتور</td>
                    <td>{{get_currency(total_product_price)}}</td>
                  </tr>
                  <tr>
                    <td>تخفیف فاکتور</td>
                    <td>{{get_currency(total_product_off_price)}}</td>
                  </tr>
                  <tr>
                    <td>هزینه ارسال</td>
                    <td>{{get_currency(order_info.shipping_price_new)}}</td>
                  </tr>
                  <tr>
                    <td>قابل پرداخت</td>
                    <td>{{get_currency(order_info.total_price)}}</td>
                  </tr>
                </table>

              </CCol>
            </CRow>
            <CRow style="border: 2px solid black;">
              <CCol col="12">
                <strong>
                  پرداختی ها
                </strong>
              </CCol>
              <CCol col="12">
                <table>
                  <tr v-for="(print_pay,index) in order_info.payment_info" :key="'pay-print-'+index">
                    <td>{{ print_pay.gateway.title }}</td>
                    <td>{{get_currency(print_pay.pay_price)}}</td>
                  </tr>
                </table>

              </CCol>
            </CRow>
            <div style="margin-top: 10px;border: 1px solid black">
              <div style="text-align: center;">
                شماره تماس فروشگاه: 02177464890
              </div>
              <div style="text-align: center;margin-top: 10px;padding: 2px">
                با معرفی هر شخص ، 3% از خرید او به کیف پول شما واریز می شود
              </div>
            </div>
          </div>

        </div>
        <CRow>
          <CCol col="6 col-sm-3"><label>شماره سفارش : {{ order_info.id }}</label></CCol>
          <CCol col="6 col-sm-3"><label>مشتری : {{ order_info.user.name }}</label></CCol>
          <CCol col="6 col-sm-3"><label>موبایل : {{ order_info.user.phone }}</label></CCol>
          <CCol col="6 col-sm-3"><label>تاریخ ثبت : {{ get_date_time(order_info.date) }}</label></CCol>
          <CCol col="6 col-sm-3"><label>نوع ارسال : {{ order_info.shipping_title }}</label></CCol>

        </CRow>
      </CCardBody>

    </CCard>
    <CCard>
      <CCardHeader>
          <CCol col="6">
            <strong>
              آدرس
            </strong>
          </CCol>
          <CCol col="6">
            <CButton
                @click="address_list_modal=true"
                color="success"
                class="mx-1">
              ویرایش آدرس
            </CButton>
          </CCol>
      </CCardHeader>
      <CCardBody class="">
        <CRow>
          <CCol>
            <div>
              <label class="mx-3">استان: {{ order_info.address.province }}</label>
              <label class="mx-3">شهر: {{ order_info.address.city }}</label>
              <p>{{ order_info.address.address }}</p>
              <label class="mx-3"> کد پستی: {{ order_info.address.post_code }}</label>
              <label class="mx-3"> نام گیرنده: {{ order_info.address.receiver }}</label>
              <label class="mx-3"> موبایل گیرنده: {{ order_info.address.mobile }}</label>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol><label>توضیحات : {{ order_info.description }}</label></CCol>
        </CRow>

      </CCardBody>

    </CCard>
    <CCard>
      <CCardHeader>
        <strong>
          محصولات سفارش
        </strong>

      </CCardHeader>
      <CCardBody class="">
        <CDataTableFixed
            :items="order_info.products"
            :fields="fields_products"

            :items-per-page="20"
            hover
            sorter
            pagination
        >
          <template #row="{item,index}">
            <td>
              <p class="text-muted">{{ index + 1 }}</p>
            </td>
          </template>

          <template #image="{item,index}">
            <td>
              <img v-if="item.image.image!=''" :src="item.image.image" style="width: 75px;height: 75px" class="text-muted"/>
            </td>
          </template>
          <template #bundles="{item,index}">
            <td v-if="item.price_rel!=null">
              <p>{{ item.price_rel.code }}</p>
              <p v-for="bundle in item.price_rel.bundles">
                {{ bundle.bundle_item.title.title }}
              </p>
            </td>
            <td v-else></td>
          </template>

          <template #price="{item,index}">
            <td>
              <p class="text-muted">{{ get_currency(item.price) }}</p>
            </td>
          </template>
          <template #off="{item,index}">
            <td>
              <p class="text-muted">{{ get_currency(item.off) }}</p>
            </td>
          </template>
          <template #tax="{item,index}">
            <td>
              <p class="text-muted">{{ get_currency(item.tax) }}</p>
            </td>
          </template>
          <template #total_price="{item,index}">
            <td>
              <p class="text-muted">{{ get_currency(item.total_price) }}</p>
            </td>
          </template>
          <template #caption>
            <tr style="background: #0d6efd;color: white" class="total-price">
              <td></td>
              <td>جمع کل</td>

              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ get_currency(calculate_items(order_info.products, 'total_price')) }}</td>

            </tr>

          </template>


        </CDataTableFixed>

      </CCardBody>

    </CCard>
    <CCard>
      <CCardHeader>
        وضعیت های پرداخت
      </CCardHeader>
      <CCardBody>
        <div v-if="snappay_status_info.successful!=null">
          <div  v-if="snappay_status_info.successful==true">
           <div v-if="snappay_status_info.response.status=='SETTLE'" class="text-success">
             پرداخت اسنپ پی با موفقیت با مبلغ {{get_currency(snappay_status_info.response.amount)}} ریال انجام شده است
           </div>
            <div v-if="snappay_status_info.response.status=='CANCEL'" class="text-danger">
             وضعیت سفارش در اسنپ پی لغو شده است
           </div>
          </div>
          <div v-else class="text-danger">
            خطا پرداخت اسنپ پی:
            {{ snappay_status_info.errorData.message }}
          </div>

        </div>
        <CDataTableFixed
            :items="order_info.payment_info"
            :fields="fields_payments"

            :items-per-page="20"
            hover
            sorter
            pagination
        >
          <template #gateway="{item}">
            <td>
              <p class="text-muted">{{ item.gateway.title }}</p>
            </td>
          </template>
          <template #updated_at="{item}">
            <td>
              <p class="text-muted">{{ get_date_time(item.updated_at) }}</p>
            </td>
          </template>
          <template #status="{item}">
            <td>
              <p class="text-danger" v-if="item.status==0">پرداخت نشده</p>
              <p class="text-success" v-if="item.status==1">پرداخت شده</p>
            </td>
          </template>

          <template #pay_price="{item}">
            <td>
              <p class="text-muted">{{ get_currency(item.pay_price) }}</p>
            </td>
          </template>
          <template #caption>
            <tr style="background: #0d6efd;color: white" class="total-price">
              <td>جمع کل</td>
              <td></td>

              <td></td>
              <td>{{ get_currency(calculate_items(order_info.payment_info, 'pay_price')) }}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

          </template>
        </CDataTableFixed>

      </CCardBody>
    </CCard>
    <CCard>
      <CCardHeader>
        <strong>
          وضعیت های سفارش
        </strong>

      </CCardHeader>


      <CCardBody class="">

        <CRow v-if="order_info.statuses[0].id!=5">
          <CCol col="5">
            <CSelect
                :options="status_items"
                horizontal
                :value.sync="selected_status"
                label="انتخاب وضعیت"
            />
          </CCol>
          <CCol col="3">

            <CButton
                color="primary"
                variant="outline"
                square
                size="sm"
                @click="change_status_confirm()"
            >تغییر وضعیت
            </CButton>
          </CCol>
        </CRow>
        <CDataTableFixed
            :items="order_info.statuses"
            :fields="fields_status"

            :items-per-page="20"
            hover
            sorter
            pagination
        >
          <template #row="{item,index}">
            <td>
              <p class="text-muted">{{ index + 1 }}</p>
            </td>
          </template>
          <template #date="{item,index}">
            <td>
              <p class="text-muted">{{ get_date_time(item.date) }}</p>
            </td>
          </template>

          <template #user="{item,index}">
            <td>
              <p class="text-muted">{{ (item.user.name) }}</p>
            </td>
          </template>


        </CDataTableFixed>

      </CCardBody>

    </CCard>
    <CModal
        title="ثبت کد رهیگیری"
        color="info"
        :show.sync="tracking_post_modal"
    >
      <CInput
          v-model="tracking_post"
          placeholder="کد رهگیری مرسوله"

      />
      <template #footer>
        <CButton @click="tracking_post_modal = false" color="danger">انصراف</CButton>
        <CButton @click="add_tracking_post()" color="success">تایید</CButton>
      </template>
    </CModal>
    <CModal
        title="ویرایش آدرس"
        color="info"
        :show.sync="edit_address_modal"
    >
      <CRow>
        <CCol col="6">
          <CSelect
              :options="provinces"
              :value.sync="selected_address_edit.province_id"
              label="استان"
          />
        </CCol>
        <CCol col="6">
          <CSelect
              :options="cities"
              :value.sync="selected_address_edit.city_id"
              label="شهر"
          />
        </CCol>
        <CCol col="6">
          <CInput
              label="کد پستی"
              v-model="selected_address_edit.post_code"/>
        </CCol>
        <CCol col="6">
          <CInput
              label="گیرنده"
              v-model="selected_address_edit.title"/>
        </CCol>
        <CCol col="6">
          <CInput
              label="موبایل"
              v-model="selected_address_edit.another_mobile"/>
        </CCol>
        <CCol col="12">
          <CTextarea
              label="آدرس"
              v-model="selected_address_edit.address"/>
        </CCol>


      </CRow>
      <template #footer>
        <CButton @click="edit_address_modal = false" color="danger">انصراف</CButton>
        <CButton @click="edit_address()" color="success">ویرایش آدرس</CButton>
      </template>
    </CModal>
    <CModal
        title="لیست آدرس ها"
        color="info"
        :show.sync="address_list_modal"
    >
      <CRow>
        <CDataTableFixed
            :items="all_addresses"
            :fields="fields_address"

            :items-per-page="20"
            hover
            sorter
            pagination


        >
          <template #province="{item}">
            <td :class="`${item.id==order_info.address.id?'bg-success':''}`">
              <p class="text-muted">{{ item.province_rel.title }}</p>
            </td>
          </template>
          <template #city="{item}">
            <td :class="`${item.id==order_info.address.id?'bg-success':''}`">
              <p class="text-muted">{{ item.city_rel.title }}</p>
            </td>
          </template>
          <template #title="{item}">
            <td :class="`${item.id==order_info.address.id?'bg-success':''}`">
              <p class="text-muted">{{ item.title }}</p>
            </td>
          </template>
          <template #another_mobile="{item}">
            <td :class="`${item.id==order_info.address.id?'bg-success':''}`">
              <p class="text-muted">{{ item.another_mobile }}</p>
            </td>
          </template>
          <template #address="{item}">
            <td :class="`${item.id==order_info.address.id?'bg-success':''}`">
              <p class="text-muted">{{ item.address }}</p>
            </td>
          </template>
          <template #is_active="{item}">
            <td :class="`${item.id==order_info.address.id?'bg-success':''}`">
              <p class="text-muted bg-success" v-if="item.id==order_info.address.id">آدرس سفارش</p>
              <CButton @click="set_address_for_order(item)" size="sm" color="primary" v-else>
                انتخاب آدرس</CButton>
              <CButton @click="address_list_modal=false,edit_address_modal=true,selected_address_edit=item" size="sm" color="warning">
                ویرایش آدرس</CButton>

            </td>
          </template>



        </CDataTableFixed>

      </CRow>
      <template #footer>
        <CButton @click="address_list_modal = false" color="danger">بستن</CButton>
      </template>
    </CModal>

  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../main";


export default {
  name: 'Login',
  components: {
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {
      logo_image:localStorage.getItem("logo_url")?localStorage.getItem("logo_url") : '/img/panel_icon.png',

      delete_tag: new Date() + "_delete_confirm",
      change_status_tag: new Date() +this.$vnode.tag+ "_change_status",
      tracking_post_modal: false,
      tracking_post: '',
      address_list_modal:false,
      selected_address_edit: {},
      edit_address_modal: false,
      all_addresses: [],
      snappay_status_info: {},
      provinces: [],
      cities: [],
      total_product_price:0,
      total_product_off_price:0,
      edit_product_weight: '',
      name: '',
      fields_products: [
        {key: 'row', label: '#', _style: 'width:3%'},
        {key: 'image', label: 'تصویر', _style: 'width:5%;'},
        {key: 'title', label: 'کالا', _style: 'width:15%;'},
        {key: 'bundles', label: 'مشخصات', _style: 'width:10%;'},
        {key: 'count', label: 'تعداد', _style: 'width:5%;'},

        {key: 'price', label: 'مبلغ', _style: 'width:10%'},
        {key: 'off', label: 'تخفیف', _style: 'width:10%;'},
        {key: 'tax', label: 'مالیات', _style: 'width:10%;'},
        {key: 'total_price', label: 'مبلغ نهایی', _style: 'width:10%;'},

      ],
      fields_status: [
        {key: 'title', label: 'وضعیت', _style: 'width:10%;'},

        {key: 'user', label: 'ثبت کننده', _style: 'width:10%'},
        {key: 'date', label: 'تاریخ ثبت', _style: 'width:10%;'},

      ],
      fields_address: [
        {key: 'province', label: 'استان', _style: 'width:10%'},
        {key: 'city', label: 'شهر', _style: 'width:10%;'},
        {key: 'title', label: 'گیرنده', _style: 'width:10%;'},
        {key: 'address', label: 'آدرس', _style: 'width:10%;'},
        {key: 'is_active', label: 'آدرس سفارش', _style: 'width:10%;'},

      ],
      fields_payments: [
        {key: 'pay_code', label: 'شماره پرداخت', _style: 'width:10%;'},

        {key: 'gateway', label: 'درگاه', _style: 'width:10%'},
        {key: 'status', label: 'وضعیت', _style: 'width:10%'},
        {key: 'pay_price', label: 'مبلغ', _style: 'width:10%'},
        {key: 'reference_number', label: 'رفرنس', _style: 'width:10%'},
        {key: 'card_number', label: 'شماره کارت', _style: 'width:10%'},
        {key: 'updated_at', label: 'تاریخ ثبت', _style: 'width:10%;'},

      ],

      product_weight: null,
      items_tags: [],
      items_tags_title: null,
      items_tags_id: 1,
      edit_items_tags_id: 0,

      productId: null,
      file: '',
      car_refer_description: '',
      color: '',
      order_info: {},
      weightModal: false,
      previewImage: '',
      description: '',
      weights: null,

      status_items: [],
      selected_status: 0,

      refer_status_items: [],
      selected_refer_status: 0,


      items_active: [],
      items_process: [],
      items_in_way: [],
      items_sent: [],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  },
  mounted() {
    this.get_provinces();

    bus.$on(this.delete_tag, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();
      } else {
        this.status_form = 0;
      }
    });
    bus.$on(this.change_status_tag, (data) => {
      // alert(data);
      if (data == 'true') {
        this.change_status();
      }
    });
  },
  watch: {
    'order_info.address.province_id': function () {
      this.get_cities()
    },
    '$route.params.order_id': function () {
      this.get_provinces();

      // this.get_order_info()
    }
  },
  methods: {
    change_status_confirm(){
      if(this.selected_status!=5){
        this.change_status()
      }else{
        this.$root.modal_component.show_confirm_modal(this.$t("warning"), "آیا از لغو سفارش اطمینان دارید؟ \n  پس از لغو امکان ویرایش سفارش وجود ندارد", [this.$t("ok")], this.change_status_tag);

      }
    },
    print() {
      this.print_element("print_order_area", "print")

    },
    get_order_info() {
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();
      formData.append("id", this.$route.params.order_id);
      formData.append("token", localStorage.getItem("token"));
      axios.post('/api/admin/order/get_order', formData, {}).then(function (response) {

        var contents = response.data;

        self.order_info = contents.data;
        self.all_addresses = contents.addresses;
        if (self.order_info.credit != null) {
          let payed_price = 0;
          if (self.order_info.payment_info.filter(x => x.status == 1).length > 0) {
            payed_price = self.order_info.payment_info.filter(x => x.status == 1)[0].pay_price
          }
          let obj = {
            pay_code: self.order_info.credit.id,
            gateway: {},
            status: 1,
            pay_price: (self.order_info.credit.price * -1) - payed_price,
            reference_number: '',
            card_number: '',
            updated_at: self.order_info.credit.updated_at
          }
          obj.gateway.title = 'کیف پول'
          if (obj.pay_price != 0) {
            self.order_info.payment_info.push(obj)

          }
        }
        if (self.order_info.off_coupon != null) {
          let payed_price = 0;
          if (self.order_info.payment_info.filter(x => x.status == 1).length > 0) {
            payed_price = self.order_info.payment_info.filter(x => x.status == 1)[0].pay_price
          }
          let obj = {
            pay_code: self.order_info.off_coupon.title,
            gateway: {},
            status: 1,
            pay_price:0,
            reference_number: '',
            card_number: '',
            updated_at: self.order_info.updated_at
          }
          let product_price = 0;
          self.order_info.products.forEach(function (val) {

            product_price += parseInt(val.total_price)
          })
          if (self.order_info.off_coupon.is_percent == 1) {
            obj.pay_price = ((self.order_info.off_coupon.amount) * (product_price)) / 100;
          } else {
            obj.pay_price = self.order_info.off_coupon.amount

          }
          obj.gateway.title = 'کد تخفیف'
          if (obj.pay_price != 0) {
            self.order_info.payment_info.push(obj)

          }
        }
        self.total_product_price = 0;
        self.total_product_off_price = 0;
        self.order_info.products.forEach(function (val) {
          self.total_product_price+=(parseInt(val.price)*parseInt(val.count))
          self.total_product_off_price+=(parseInt(val.off)*parseInt(val.count))
        })
        // self.order_info.products.push({
        //   image:{image:''},
        //   title:self.order_info.shipping_title,
        //   price:self.order_info.shipping_price_new,
        //   off:0,
        //   tax:0,
        //   count:1,
        //   total_price:self.order_info.shipping_price_new,
        // })
// if(self.order_info.payment_info[0].gateway_id==3){
//   self.get_snappay_info()
// }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_address() {
      var self = this;
      self.edit_address_modal = false

      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();
      formData.append("id", this.selected_address_edit.id);
      formData.append("address", this.selected_address_edit.address);
      formData.append("province", this.selected_address_edit.province_id);
      formData.append("city", this.selected_address_edit.city_id);
      formData.append("receiver", this.selected_address_edit.title);
      formData.append("mobile", this.selected_address_edit.another_mobile);
      formData.append("post_code", this.selected_address_edit.post_code);
      axios.post('/api/admin/user/edit_user_address', formData, {}).then(function (response) {
        if (response.data.error == 1) {
          self.$root.modal_component.show_danger_modal('خطا', response.data.msg);

        } else {
          self.$root.modal_component.show_success_modal('تایید', response.data.msg);

        }
        self.get_order_info();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    set_address_for_order(item) {
      var self = this;
      self.address_list_modal = false

      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();
      formData.append("address_id", item.id);
      formData.append("order_id", this.order_info.id);

      axios.post('/api/admin/order/edit_order_address', formData, {}).then(function (response) {
        if (response.data.error == 1) {
          self.$root.modal_component.show_danger_modal('خطا', response.data.msg);

        } else {
          self.$root.modal_component.show_success_modal('تایید', response.data.msg);

        }
        self.get_order_info();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    change_status() {
      var self = this;
      var formData = new FormData();
      formData.append("id", this.$route.params.order_id);
      formData.append("status", this.selected_status);
      formData.append("token", localStorage.getItem("token"));
      axios.post('/api/admin/order/change_order_status', formData, {}).then(function (response) {

        if (response.data.error == 1) {
          self.$root.modal_component.show_danger_modal('خطا', response.data.msg);

        } else {
          self.$root.modal_component.show_success_modal('تایید', response.data.msg);

        }
        self.get_order_info();

        // self.description = '';
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    add_tracking_post() {
      var self = this;
      var formData = new FormData();
      formData.append("id", this.$route.params.order_id);
      formData.append("tracking_code", this.tracking_post);
      formData.append("token", localStorage.getItem("token"));
      this.tracking_post_modal = false
      axios.post('/api/admin/order/add_order_tracking_post', formData, {}).then(function (response) {

        if (response.data.error == 1) {
          self.$root.modal_component.show_danger_modal('خطا', response.data.msg);

        } else {
          self.$root.modal_component.show_success_modal('تایید', response.data.msg);

        }
        self.get_order_info();

        // self.description = '';
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_provinces() {
      var self = this;


      const formData = new FormData();
      var url = "/api/market/get_shipping";

      formData.append('id', this.selected_province);

      axios.post(url, formData, {}).then(function (response) {

        response.data.provinces.forEach(function (val) {
          self.provinces.push(
              {label: val.title, value: val.id}
          )
        })
        self.get_status_list();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cities() {
      var self = this;


      const formData = new FormData();
      var url = "/api/market/get_cities";

      formData.append('id', this.order_info.address.province_id);

      axios.post(url, formData, {}).then(function (response) {
        self.cities = [{label: 'انتخاب کنید', value: 0}]
        response.data.data.forEach(function (val) {
          self.cities.push(
              {label: val.title, value: val.id}
          )
        })

        // self.order_info.address.city_id = response.data.data[0].id


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_status_list() {
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();

      axios.post('/api/admin/order/get_order_status', formData, {}).then(function (response) {

        var contents = response.data;
        self.status_items = []
        contents.orders.forEach(function (val) {
          self.status_items.push(
              {label: val.title.title, value: val.id}
          )
        })

        self.selected_status = self.status_items[0].value;
        self.get_order_info();

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_snappay_info(){
      var self = this;

      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();
      formData.append("id", this.order_info.id);

      axios.post('/api/admin/order/get_snaapay_status', formData, {}).then(function (response) {
  self.snappay_status_info = response.data


      })
          .catch(function (error) {

            console.log(error);
          });

    },
  }
}


</script>
